import { createRouter, createWebHistory } from 'vue-router'
import AU from '@/components/Panel'
import KR from '@/components/Panel'
import MY from '@/components/Panel'
import TW from '@/components/Panel'
import SG from '@/components/Panel'
import JP from '@/components/Panel'
import PopUpPanel from '@/components/PopUp/PopUpPanel'

const routes = [
  {
    path: '/',
    name: 'home',
    component: AU
  },
  {
    path: '/KR',
    name: 'KR',
    component: KR
  },
  {
    path: '/TW',
    name: 'TW',
    component: TW
    
  },
  {
    path: '/MY',
    name: 'MY',
    component: MY
  },
    {
    path: '/JP',
    name: 'JP',
    component: JP
  },
  {
    path: '/SG',
    name: 'SG',
    component: SG
  },
  {
    path: '/popup',
    name: 'popup',
    component: PopUpPanel
  }
  
]

const router = createRouter({
  history: createWebHistory(),
  routes
})



export default router
